import { gql } from "@apollo/client";

export const CHECK_APP_UPDATE = gql`
  query CheckAppUpdate($type: String!, $versionName: String) {
    checkAppUpdate(type: $type, versionName: $versionName) {
      needUpdate
      isForceUpdate
      latestVersion {
        versionName
        url
        updateContent {
          zh
          en
          es
        }
      }
    }
  }
`;

export interface UpdateContentType {
    zh: string | null;
    en: string | null;
    es: string | null;
}

export interface AppVersionCheckVersionType {
    versionName: string;
    url: string;
    updateContent: UpdateContentType | null;
}

export interface CheckAppUpdateResponse {
    checkAppUpdate: {
        needUpdate: boolean;
        isForceUpdate: boolean;
        latestVersion: AppVersionCheckVersionType | null;
    };
}

export interface CheckAppUpdateVariables {
    type: string;
    versionName?: string;
}
